import DeadlineEditor from "../controls/task/DeadlineEditor";

export default class TaskManagementDeadlineEditor extends DeadlineEditor {
    constructor($containerEl, ediatable, dateFormat) {
        super($containerEl, ediatable);
        this.setDateFormat(dateFormat);
    }

    formatDate() {
        return this.dateFormat.formatDate(this.deadline);
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/DeadlineEditor.js